import type { StepData } from "../Workflow";
import { Icon } from "../Icon";
import { LinkTooltip } from "../LinkTooltip";

type Props = {
  step: StepData;
  incomingFromStepIds: string[];
  copyableUrl: string | null;
  copyableEmail: string | null;
};

export function EndpointBadges({
  step,
  incomingFromStepIds,
  copyableUrl,
  copyableEmail,
}: Props) {
  if (incomingFromStepIds.length > 0) return null;

  const hasUrl = step.edgeRoute && copyableUrl;
  const hasEmail = step.emailAddress && copyableEmail;
  if (!hasUrl && !hasEmail) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        flexShrink: 0,
      }}
      data-card-chip
    >
      {hasUrl && (
        <LinkTooltip url={copyableUrl}>
          <span style={{ display: "flex", cursor: "pointer" }}>
            <Icon name="link-2" size={12} color={`var(--${step.color}-1000)`} />
          </span>
        </LinkTooltip>
      )}
      {hasEmail && (
        <LinkTooltip url={copyableEmail} openUrl={`mailto:${copyableEmail}`}>
          <span style={{ display: "flex", cursor: "pointer" }}>
            <Icon
              name="at-sign"
              size={12}
              color={`var(--${step.color}-1000)`}
            />
          </span>
        </LinkTooltip>
      )}
    </div>
  );
}
